import "./Sustainability.module.css";
import Header from "@/reusable_sections/Header";
import CompromisoDeSostenibilidad from "./sections/CompromisoDeSostenibilidad";
import HistoriaCorporativa from "./sections/HistoriaCorporativa";
import CompromisoAmbiental from "./sections/CompromisoAmbiental";
import PrCticasDeSostenibilidad from "./sections/PrCticasDeSostenibilidad";
import NeteANuestraIniciativa from "./sections/NeteANuestraIniciativa";
import Footer from "@/reusable_sections/Footer";
export default function SustainabilityPage() {
  return <div>
      <Header />
      <CompromisoDeSostenibilidad />
      <HistoriaCorporativa />
      <CompromisoAmbiental />
      <PrCticasDeSostenibilidad />
      <NeteANuestraIniciativa />
      <Footer />
    </div>;
}